// @flow
import * as React from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import querystring from "querystring";
import { get } from "./common/fetch";

// Белый список параметров, которые следует отправить при регистрации
const SIGN_IN_PARAMETERS = [
  "subid",
  "site_domain",
  "clickid",
  "sub0",
  "sub1",
  "sub2",
  "sub3",
  "sub4",
  "sub5",
  "sub6",
  "sub7",
  "sub8",
  "sub9"
];

// Белый список параметров, которые мы шлём в стату при каждом посещении
const LOG_IN_PARAMETERS = ["sub7", "sub8", "sub9", "notification_id"];

// Клеим рандом строку к ключу стораджа чтобы если что — ретироваться
const HASHED_STORAGE_KEY_SIGN_IN = "subzero_dgetwbcl";
const HASHED_STORAGE_KEY_LOG_IN = "subzero_gvrh3pfk";

export function readSignInParameters() {
  let payload = null;

  try {
    payload = localStorage.getItem(HASHED_STORAGE_KEY_SIGN_IN);
  } catch (error) {}

  try {
    return payload != null ? querystring.parse(payload) : {};
  } catch (error) {
    return {};
  }
}

export function flushSignInParameters() {
  try {
    localStorage.removeItem(HASHED_STORAGE_KEY_SIGN_IN);
  } catch (error) {}
}

export function readLogInParameters() {
  let payload = null;

  try {
    payload = localStorage.getItem(HASHED_STORAGE_KEY_LOG_IN);
  } catch (error) {}

  try {
    return payload != null ? querystring.parse(payload) : {};
  } catch (error) {
    return {};
  }
}

export function flushLogInParameters() {
  try {
    localStorage.removeItem(HASHED_STORAGE_KEY_LOG_IN);
  } catch (error) {}
}

export function getSub0(
  location: { pathname: string },
  serverData: { isIOS: boolean }
): string {
  let payload = readSignInParameters();
  if (!payload.sub0) {
    payload = readLogInParameters();
  }

  if (payload.sub0) {
    return payload.sub0;
  }

  const isHelpdesk = location.pathname.includes("helpdesk");

  const ua = window.navigator.userAgent.toLowerCase();
  // iOS Terminal
  const isIosTerminal = /com.ironterminal.ios/g.test(ua);
  // Android Webview full app
  const isWebView = /wvbo_full/g.test(ua);
  // Android Webview analytics
  const isAnalyticsWebView =
    process.env.REACT_APP_DEPLOY_TARGET === "irontrade" &&
    /androidweb.*com\.irontrade\.analytics.*wvbo/g.test(ua) &&
    !isWebView;
  // iOS Webview Analytics
  const isIosAnalyticsWebView = /iosweb.*com\.full\.iron.*wvbo_full/.test(ua);

  switch (true) {
    case isHelpdesk && serverData.isIOS:
      return "ios_helpdesk";
    case serverData.isIOS && serverData.app_version > 0:
      return "webview-ios";
    case isIosTerminal:
      return "webview-ios-terminal";
    case isIosAnalyticsWebView:
      return "webview-ios-analytics";
    case isWebView:
      return "webview-android";
    case isAnalyticsWebView:
      return "webview-android-analytics";
    case isHelpdesk:
      return "helpdesk";
    case serverData.isMobile:
      return "web-mobile";
    default:
      return "web-desktop";
  }
}

type Props = {
  location: { pathname: string, search: string },
  serverData: { isIOS: boolean }
};

class PersistLogInParameters extends React.Component<Props> {
  componentDidMount() {
    const query = querystring.parse(this.props.location.search.slice(1));
    const toPersist = Object.keys(query).filter(p =>
      LOG_IN_PARAMETERS.includes(p)
    );

    if (toPersist.length > 0) {
      const payload = toPersist.reduce((payload, p) => {
        payload[p] = query[p];
        return payload;
      }, {});

      if (!("sub0" in payload)) {
        payload.sub0 = getSub0(this.props.location, this.props.serverData);
      }

      try {
        localStorage.setItem(
          HASHED_STORAGE_KEY_LOG_IN,
          querystring.stringify(payload)
        );
      } catch (error) {}
    }
  }
  render() {
    return null;
  }
}

class PersistSignInParameters extends React.Component<Props> {
  componentDidMount() {
    const query = querystring.parse(this.props.location.search.slice(1));
    const toPersist = Object.keys(query).filter(p =>
      SIGN_IN_PARAMETERS.includes(p)
    );

    if (toPersist.length > 0) {
      const payload = toPersist.reduce((payload, p) => {
        payload[p] = query[p];
        return payload;
      }, {});

      if (!("sub0" in payload)) {
        payload.sub0 = getSub0(this.props.location, this.props.serverData);
      }

      try {
        localStorage.setItem(
          HASHED_STORAGE_KEY_SIGN_IN,
          querystring.stringify(payload)
        );
      } catch (error) {}
    }
  }
  render() {
    return null;
  }
}

class SubmitLogInParameters extends React.Component<Props> {
  componentDidMount() {
    const query = querystring.parse(this.props.location.search.slice(1));
    const toSubmit = Object.keys(query).filter(p =>
      LOG_IN_PARAMETERS.includes(p)
    );

    if (toSubmit.length > 0) {
      const payload = toSubmit.reduce((payload, p) => {
        payload[p] = query[p];
        return payload;
      }, {});

      if (!("sub0" in payload)) {
        payload.sub0 = getSub0(this.props.location, this.props.serverData);
      }

      get(`/api/rewrite-sub?${querystring.stringify(payload)}`);
    } else {
      const payload = readLogInParameters();

      if (Object.keys(payload).length > 0) {
        get(`/api/rewrite-sub?${querystring.stringify(payload)}`).then(() => {
          flushLogInParameters();
        });
      }
    }
  }
  render() {
    return null;
  }
}

function Subzero(props) {
  if (props.serverData == null) {
    return null;
  } else {
    if (props.profile == null) {
      return (
        <React.Fragment>
          <PersistLogInParameters
            serverData={props.serverData}
            location={props.location}
          />
          <PersistSignInParameters
            serverData={props.serverData}
            location={props.location}
          />
        </React.Fragment>
      );
    } else {
      return (
        <SubmitLogInParameters
          serverData={props.serverData}
          location={props.location}
        />
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    serverData: state.serverData,
    profile: state.profile
  };
}

export default connect(mapStateToProps)(withRouter(Subzero));



// WEBPACK FOOTER //
// ./src/components/Subzero.js